import React, { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import "../styles/cricket-betting.css";

const CricketBettingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <div className="cricket-betting-page">
      <Helmet>
        <title>
          Reddy Anna - Cricket Betting ID India for IPL & Live Matches
        </title>
        <meta
          name="description"
          content="Get Reddy Anna cricket betting ID for IPL and live matches in India with fast signup and secure platform."
        />
        <script type="application/ld+json">
          {`
            {
 "@context": "https://schema.org",
 "@type": "Service",
 "name": "Reddy Anna - Cricket Betting ID India for IPL & Live Matches",
 "url": "https://reddyannaaid.com/cricket-betting",
 "description": "Get Reddy Anna cricket betting ID for IPL and live matches in India with fast signup and secure platform.",
 "provider": {
   "@type": "Organization",
   "name": "Reddy Anna"
 },
 "areaServed": "India"
}

          `}
        </script>
      </Helmet>
      <section className="cricket-betting-intro">
        <div className="cricket-betting-intro-content">
          <h1>
            <span className="highlight">Reddy Anna Cricket Betting:</span> Dive
            into the Ultimate Cricket Experience!
          </h1>
          <p>
            Welcome to Reddy Anna Cricket Betting, where passion for cricket
            meets the thrill of betting. Whether you're a die-hard fan or simply
            looking for added excitement, our platform offers an unparalleled
            experience.
          </p>
          <div className="cricket-betting-cta-buttons">
            <a
              href={whatsappLink}
              className="contactus-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Your Demo Account
            </a>
            <a
              href={ContactLink}
              className="contactus-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="cricket-betting-intro-image">
          <img
            src="/cricket-betting.webp"
            alt="Cricket Betting"
            className="cricket-image"
          />
        </div>
      </section>

      <section className="cricket-betting-features">
        <h2>
          Highlights of <span>Reddy Anna Cricket Betting</span>
        </h2>
        <ol>
          <li>
            <strong>Exclusive Cricket ID:</strong> Get your Reddy Anna Cricket
            ID and unlock the door to unmatched cricket betting opportunities.
            It's your key to an immersive betting experience.
          </li>
          <li>
            <strong>Seamless Registration:</strong> Creating an account is quick
            and simple. Enjoy easy registration and hassle-free login to start
            betting on your favorite cricket matches.
          </li>
          <li>
            <strong>Dedicated Mobile App:</strong> Take the action with you by
            downloading the Reddy Anna Cricket Betting App. Get instant updates,
            track odds, and place bets on the go.
          </li>
          <li>
            <strong>Reliable Support:</strong> Connect with our support team via
            WhatsApp or phone. We're here to answer your questions and ensure a
            smooth betting journey.
          </li>
        </ol>
        <div className="cricket-betting-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="cricket-betting-getting-started">
        <h2>
          Getting Started with <span>Reddy Anna Cricket Betting</span>
        </h2>
        <ol>
          <li>
            <strong>Sign Up:</strong> Visit our site or download the app to
            create your Reddy Anna Cricket ID. Complete the registration form to
            begin.
          </li>
          <li>
            <strong>Log In:</strong> Use your credentials to log into your
            account and access all the exciting betting options.
          </li>
          <li>
            <strong>Explore Options:</strong> Browse through a wide selection of
            matches, leagues, and tournaments. From local games to global
            showdowns, we cover it all.
          </li>
          <li>
            <strong>Place Bets:</strong> Choose your match, select a betting
            option, and place your bets with ease. Watch live updates as the
            game unfolds.
          </li>
          <li>
            <strong>Support Anytime:</strong> Need assistance? Our customer
            support is just a call or message away, ready to help you enjoy a
            seamless experience.
          </li>
        </ol>
        <div className="cricket-betting-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="cricket-betting-join">
        <h2>
          Become a Part of <span>Reddy Anna</span> Today!
        </h2>
        <p>
          Enhance your cricket experience with top-tier odds, an intuitive
          interface, and unparalleled customer support. Join Reddy Anna Cricket
          Betting and play smart, responsibly.
        </p>
        <div className="cricket-betting-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default CricketBettingPage;
